import React, { Component } from 'react';
import { getList } from '../function/get-data';
import ModalGenerateForm from '../feature/pelayanan-surat/modal/surat-generate-form';

const frmSurat = {
	uuid: '',
	id_jenis: '',
	nik_pelapor: '',
	nik: '',
	nama_pemohon: '',
	tempat_lahir: '',
	tanggal_lahir: '',
	jenis_kelamin: '',
	status_perkawinan: '',
	pekerjaan: '',
	agama: '',
	alamat: '',
	pendidikan_terakhir: '',
	kewarganegaraan: '',
	tujuan_pembuatan: '-',
}

export default class SuratGenerateForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			Basic: false,
			status: {
				view: false,
				form: false,
				btnForm: false,
				btnAksi: false,
			},

			dt: frmSurat,
		
			field_inputan:[],
			formSelect:null,
			formSelectPenduduk:null,
			detailStatus: [],
			status_data:"create",
			status_generate_form: true,
			
		};
	}

	setFieldInputan() {
		let field_inputan = JSON.parse(this.props.detailSurat.field_inputan)
		// console.log('field_inputan')
		// console.log(field_inputan)
	
		let formSelect = {};
		let formSelectPenduduk = {};
		let manualStatus = {};
		let detailStatus = {};
		let pemohonStatus= {};
	
		Object.keys(field_inputan).forEach((data_level1) => {
	
			detailStatus = {
				...detailStatus,
				[data_level1]: true,
			}
			
			formSelectPenduduk[data_level1] = {}
			manualStatus[data_level1] = null
	
			field_inputan[data_level1].forEach((data,key) => {
		
				if(Array.isArray(data)){
					field_inputan[data_level1] = [field_inputan[data_level1]]
				
					data.forEach((data2,key2) => {
						if(data2.type === "select"){
				
							if(data2.option.length > 0){
								let optionValue = []
					
								data2.option.forEach((dtOption, key) => {
									optionValue.push({ value: dtOption, label: dtOption });
								})
					
								formSelect= {
									...formSelect,
									[data2.key]:optionValue
								}
					
							}
							else{
								let optionValue = []
					
								optionValue = getList(data2.model,'')
								
								formSelect= {
									...formSelect,
									[data2.key]:optionValue
								}
							}
						}
						else if(data2.type === "nik"){
							detailStatus = {
								...detailStatus,
								[data_level1]: {
									...detailStatus[data_level1],
									0: false,
								}
							}
				
							let optionValue = []
					
							optionValue = getList(data2.model,'')
					
							formSelectPenduduk[data_level1] = {
								...formSelectPenduduk[data_level1],
								[key]:{
									[data2.key]: optionValue,
								}
							}
			
							manualStatus[data_level1] = {
								...manualStatus[data_level1],
								[key]: null
							}
			
							pemohonStatus = {
								...pemohonStatus,
								[data_level1]: {
									...pemohonStatus[data_level1],
									[key]: null,
								}
							}
						}
						else if(data2.type === "perangkat"){
							detailStatus = {
								...detailStatus,
								[data_level1]: {
									...detailStatus[data_level1],
									0: false,
								}
							}
					
							let optionValue = []
					
							optionValue = getList(data2.model,'')
					
							formSelect[data_level1] = {
								...formSelect[data_level1],
								[key]:{
									[data2.key]: optionValue,
								}
							}
			
							manualStatus[data_level1] = {
								...manualStatus[data_level1],
								[key]: true
							}
			
							pemohonStatus = {
								...pemohonStatus,
								[data_level1]: {
									...pemohonStatus[data_level1],
									[key]: null,
								}
							}
						}
			
					})
				}
				else{
					if(data.type === "select"){
			
						if(data.option.length > 0){
							let optionValue = []
				
							data.option.forEach((dtOption, key) => {
								optionValue.push({ value: dtOption, label: dtOption });
							})
				
							formSelect= {
								...formSelect,
								[data.key]:optionValue
							}
			
						}
						else{
							let optionValue = []
				
							optionValue = getList(data.model,'')
							
							formSelect= {
								...formSelect,
								[data.key]:optionValue
							}
						}
					}
					else if(data.type === "nik"){
						detailStatus = {
							...detailStatus,
							[data_level1]: false,
						}
			
						// let optionValue = []
			
						// optionValue = getList(data.model,'')
			
						formSelectPenduduk[data_level1] = {
							...formSelectPenduduk[data_level1],
							[data.key]: this.props.anggotaKeluarga,
						}
			
						manualStatus[data_level1] = null
			
						pemohonStatus = {
							...pemohonStatus,
							[data_level1]: null,
						}
					}
					else if(data.type === "perangkat"){
						detailStatus = {
							...detailStatus,
							[data_level1]: false,
						}
			
						let optionValue = []
			
						optionValue = getList(data.model,'')
			
						formSelect[data_level1] = {
							...formSelect[data_level1],
							[data.key]: optionValue,
						}
			
						manualStatus[data_level1] = true
			
						pemohonStatus = {
							...pemohonStatus,
							[data_level1]: null,
						}
					}
				}
			})
			
			this.setState({
				field_inputan: field_inputan,
				detailStatus: detailStatus,
				formSelect: formSelect,
				formSelectPenduduk: formSelectPenduduk,
				manualStatus: manualStatus,
				pemohonStatus: pemohonStatus,
			})
	
		})
	
	}

	setDetaiDataSurat() {
		let detailStatus = {}
		let dinamisTemplate = {}
		let manualStatus = {}
		let allData = frmSurat;
	
		Object.keys(this.state.field_inputan).forEach((data_level1) => {
			// console.log('this.state.field_inputan[data_level1]')
			// console.log(data_level1)
			// console.log(this.state.field_inputan[data_level1])
			if(this.state.field_inputan[data_level1]){
				if(Array.isArray(this.state.field_inputan[data_level1][0])){
					
					if(this.state.field_inputan[data_level1][0][0][0].type === 'nik'){
						detailStatus = {
							...detailStatus,
							[data_level1]: {
								...detailStatus[data_level1],
								0: false,
							}
						}
		
						manualStatus[data_level1] = {
							...manualStatus[data_level1],
							[0]: null
						}
					}
					else if(this.state.field_inputan[data_level1][0][0][0].type === 'perangkat'){
						detailStatus = {
							...detailStatus,
							[data_level1]: {
								...detailStatus[data_level1],
								0: false,
							}
						}
			
						manualStatus[data_level1] = {
							...manualStatus[data_level1],
							[0]: true
						}
					}
					else{
						detailStatus = {
							...detailStatus,
							[data_level1]: {
								...detailStatus[data_level1],
								0: true,
							}
						}
						
						manualStatus[data_level1] = {
							...manualStatus[data_level1],
							[0]: true
						}
					}
		
					allData[data_level1] = [[]]
					dinamisTemplate = {
						...dinamisTemplate,
						[data_level1]: this.state.field_inputan[data_level1][0],
					}
				}
				else{
					
					// Jika array pertama type nik, status false
					if(this.state.field_inputan[data_level1][0].type === 'nik'){
						detailStatus = {
							...detailStatus,
							[data_level1]: false,
						}
			
						manualStatus[data_level1] = null
					}
					// Jika array pertama type nik, status false
					else if(this.state.field_inputan[data_level1][0].type === 'perangkat'){
						detailStatus = {
							...detailStatus,
							[data_level1]: false,
						}
			
						manualStatus[data_level1] = true
					}
					// Jika array pertama selain nik, status true
					else{
						detailStatus = {
							...detailStatus,
							[data_level1]: true,
						}
			
						manualStatus[data_level1] = true
					}

					allData[data_level1] = []
					dinamisTemplate = {
						...dinamisTemplate,
						[data_level1]: null,
					}
				}
			}
		})
	
		dinamisTemplate = {
			...dinamisTemplate,
			nik: this.state.frmNik,
		}
	
		if(this.props.detailSurat.jenis_layanan === "Internal"){
			dinamisTemplate = {
				...dinamisTemplate,
				perangkat: this.state.frmListPerangkat
			}

			allData['data_penandatangan'] = [
				{
					key: 'uuid',
					value: '',
					pemohon: false,
				},
				{
					key: 'jabatan',
					value: '',
					pemohon: false,
				},
				{
					key: 'nama',
					value: '',
					pemohon: false,
				},
				{
					key: 'nip',
					value: '',
					pemohon: false,
				},
				{
					key: 'golongan',
					value: '',
					pemohon: false,
				},
			]
		}
	
		this.setState({
			dt: allData,
			detailStatus: detailStatus,
			dinamisTemplate: dinamisTemplate,
			manualStatus: manualStatus,
			nikStat: null,
			nik2Stat: null,
		});

	}

	componentDidMount() {
		// Get list anggota keluarga from parent
		if(this.props.detailSurat.status_generate_form === "true"){
			this.setFieldInputan();
		}
		else{
			this.setState({
				status_generate_form: false,
			})
		}

		// if (this.props.anggotaKeluarga) {
		// 	this.setState({ frmNikKeluarga: this.props.anggotaKeluarga })
		// 	this.setState({ 
		// 		frmNik: this.props.anggotaKeluarga,
		// 		tmplistPenduduk: this.props.tmplistPenduduk,
		// 	})
		// }
	}

	render() {

		const styleImgIcon = {
			height: '42,58px',
			width: '65,83px'
		};

		return (
			<div>
				{/* Modal Baru */}
				{
					this.state.status_generate_form
						?
							<ModalGenerateForm
								data={this.state.dt}
								isOpen={this.state.status.form}
								propsData={this.props}
								kiosk={true}
								fieldInputan={this.state.field_inputan}
								statusData={this.state.status_data}
								optionData={{
									detailStatus: this.state.detailStatus,
									dinamisTemplate: this.state.dinamisTemplate,
									formSelect: this.state.formSelect,
									formSelectPenduduk: this.state.formSelectPenduduk,
									frmListPerangkat: this.state.frmListPerangkat,
									manualStatus: this.state.manualStatus,
									pemohonStatus: this.state.pemohonStatus,
									accButtonPerangkatDesa: this.state.accButtonPerangkatDesa,
									listPerangkatDesa: this.state.listPerangkatDesa,
									ttdSelected: this.state.ttdSelected,
									status: this.state.status,
									dataSurat: this.props.detailSurat,
								}}
								getDataSurat={(data_surat) =>
									this.props.getDataSurat(data_surat)
								}
								getAntrian={(jenis_surat, status, uncomplete, data) =>
									this.props.getAntrian(jenis_surat, status, uncomplete, data)}
								setAlert={(e) => {
									this.setState(e)
								}}
								setIsOpen={(e) => {
									if (!e) {
										this.setState({ dt: frmSurat })
									}
									this.setState({
									status: {
										...this.state.status,
										form: e
									}
									})
								}}
							/>
						:
						<></>

				}
				{/* Modal Baru */}


				<div
					className="card kiosk-card"
					onClick={(e) => {
						if (!e) {
							this.setState({ dt: null })
						}
						this.props.getJenisSuratCard(this.props.detailSurat)
						this.setState({
							status: {
								...this.state.status,
								form: e
							}
						})
						this.setDetaiDataSurat()
					}}
					style={{
						marginTop: '20px',
						marginBottom: '20px',
						marginLeft: '10px',
						marginRight: '10px',
						height: '170px',
						minWidth: 'max-content',
						borderRadius: '20px'
					}}
				>
					<div className="card-body">
						<div
							className="row"
							style={{ display: 'flex', justifyContent: 'center', marginBottom: '12px' }}
						>
							{
								this.props.detailSurat && this.props.detailSurat.icon_kiosk
								?
									<img
										src={this.props.detailSurat.icon_kiosk}
										alt="logo"
										height="65"
										style={styleImgIcon}
									/>
								:
									<img 
										src={require("../assets/images/tes-loading.gif")} 
										alt="loading"
										style={{
											height: '70px',
										}}
									/> 
							}
						</div>
						<div className="row" style={{ display: 'flex', justifyContent: 'center' }}>
							<p
								className="mb-0"
								style={{
									fontSize: '20px',
									fontWeight: '600',
									color: '#000000'
								}}
							>
								{this.props.detailSurat.nama_mobile}
							</p>
						</div>
					</div>
				</div>
			</div>
		);
	}
}